import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Navbar.css";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
// import Hamburger from "hamburger-react";
// TODO: try adding animated hamburger menu without breaking layout

export const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const displayResponsiveMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleOutsideClick = (e) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(e.target) &&
      e.target !== buttonRef.current
    ) {
      setMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <nav>
      <Link to="/" className="navbarTitle">
        Bartosz Zborowski
      </Link>
      <div className="menuBars" onClick={displayResponsiveMenu} ref={buttonRef}>
        {menuOpen ? (
          <CloseIcon style={{ fontSize: "32px" }} />
        ) : (
          <MenuIcon style={{ fontSize: "32px" }} />
        )}
      </div>
      <ul className={menuOpen ? "open" : ""} ref={menuRef}>
        <li>
          <NavLink
            to="/"
            onClick={() => {
              setMenuOpen(false);
            }}
          >
            Home
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/portfolio"
            onClick={() => {
              setMenuOpen(false);
            }}
          >
            Portfolio
          </NavLink>
        </li>
        {/* <li>
          <NavLink
            to="/hobbies"
            onClick={() => {
              setMenuOpen(false);
            }}
          >
            Hobbies
          </NavLink>
        </li> */}
        <li>
          <NavLink
            to="/contact"
            onClick={() => {
              setMenuOpen(false);
            }}
          >
            Contact
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};
